<template>
  <div class="mainC">
    <ul class="list-group MobileHide pl-0 pr-0">
      <div v-if="cookiesObject.token">
        <li
          class="list-group-item"
          style="
            background: rgba(190, 135, 51, 0.3);
            color: white;
            line-height: 7px;
          "
          v-if="findCommonElements()"
        >
          <img
            src="@/assets/orStar.png"
            style="width: 14px; margin-top: -4px; margin-right: 5px"
            alt=""
          />{{ $t("LanguageEn.myTeamsMatches")
          }}<span style="float: right">{{ woolo }}</span>
        </li>
        <div
          v-for="fav in favs"
          :key="fav.id"
          style="width: 100%"
          class="gamebg"
        >
          <div v-for="gamee in games" :key="gamee.id">
            <li
              class="list-group-item game"
              style="background: #141416; line-height: 7px"
              v-if="fav.id == gamee.team2.id || fav.id == gamee.team1.id"
            >
              <div class="row">
                <div class="col-1 pr-3 mr-0 bodyElement">
                  <div>
                    <b-btn
                      v-if="favsTe.some((fav) => fav.id === gamee.id)"
                      v-on:click="
                        removeFavorite({ value: gamee.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/orStar.png"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                    <b-btn
                      v-else
                      v-on:click="
                        addToFavorites({ value: gamee.id, type: match })
                      "
                      style="
                        float: right;
                        background: none;
                        width: 5px;
                        height: 5px;
                        border: none;
                      "
                    >
                      <img
                        src="@/assets/favorite.svg"
                        style="
                          width: 15px;
                          margin-top: -30px;
                          margin-left: -10px;
                        "
                        alt=""
                      />
                    </b-btn>
                  </div>
                </div>
                <router-link
                  style="color: #e6e6e6"
                  class="col ml-0 pl-0"
                  id="router-link"
                  :to="{ name: 'MatchPagePar', params: { gameId: gamee.id } }"
                >
                  <div class="row">
                    <div class="col-1 bodyElement">
                      <p v-if="gamee.matchStatus.name == 'FT'">
                        {{ gamee.matchStatus.name }}
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'FT_PEN'">FT</p>
                      <p v-else-if="gamee.matchStatus.name == 'BREAK'">BR</p>
                      <p v-else-if="gamee.matchStatus.name == 'POSTP'">PST</p>
                      <p v-else-if="gamee.matchStatus.name == 'NS'">
                        {{
                          gamee.matchTime.slice(11, 16)
                            | transliterate(cookiesObject.lang)
                        }}
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'TBA'">TB</p>
                      <p v-else-if="gamee.matchStatus.name == 'AWARDED'">AWR</p>
                      <p v-else-if="gamee.matchStatus.name == 'LIVE'">
                        {{ calculateMinutes(gamee.counterStartTime)
                        }}<img
                          src="@/assets/redLight.gif"
                          style="
                            width: 5px;
                            position: absolute;
                            margin-top: -4px;
                          "
                          alt="'"
                        />
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'CANCL'">CAN</p>
                      <p v-else>{{ gamee.matchStatus.name }}</p>
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: left;'
                          : 'margin-top: -5px; text-align: right;'
                      "
                    >
                      {{ gamee.team1.name | transliterate(cookiesObject.lang) }}
                      <img
                        :src="teamLogo + gamee.team1.id"
                        alt=""
                        style="width: 20px"
                      />
                    </div>
                    <div
                      class="col-2 bodyElement"
                      v-if="
                        gamee.matchStatus.name == 'NS' ||
                        gamee.matchStatus.name == 'POSTP' ||
                        gamee.matchStatus.name == 'CANCL' ||
                        gamee.matchStatus.name == 'TBA'
                      "
                      style="letter-spacing: 3px"
                    >
                      -
                    </div>
                    <div
                      class="col-2 bodyElement"
                      style="letter-spacing: 3px"
                      v-else
                    >
                      {{
                        gamee.currentScore | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div
                      class="col bodyElement"
                      :style="
                        rtl
                          ? 'margin-top: -5px; text-align: right;'
                          : 'margin-top: -5px; text-align: left;'
                      "
                    >
                      <img
                        :src="teamLogo + gamee.team2.id"
                        alt=""
                        style="width: 20px"
                      />
                      {{ gamee.team2.name | transliterate(cookiesObject.lang) }}
                    </div>
                  </div>
                </router-link>
                <div class="col-2 ml-0 pl-5 bodyElement" style="">
                  <div>
                    <span
                      v-if="
                        gamee.betEnabled == 1 && gamee.predictionValue != null
                      "
                      style="
                        border: 1px solid #444548;
                        background: #27292c;
                        border-radius: 2px;
                        padding: 3px;
                        letter-spacing: 2px;
                        color: #e6e6e6;
                      "
                    >
                      {{ gamee.predictionValue }}
                    </span>
                    <span
                      v-else-if="
                        gamee.betEnabled == 1 &&
                        gamee.predictionValue == null &&
                        gamee.matchStatus.name == 'NS'
                      "
                    >
                      <router-link
                        style="color: #e6e6e6; text-decoration: none"
                        class=""
                        id=""
                        :to="{
                          name: 'MatchPagePar',
                          params: { gameId: gamee.id, index: 3 },
                        }"
                      >
                        <img
                          style="width: 24px; margin-top: -8px"
                          src="@/assets/scoreboard.svg"
                        />
                      </router-link>
                    </span>
                    <span v-else style=""></span>
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>
      <b-spinner
        variant="success"
        label="Spinning"
        style="
          width: 3rem;
          height: 3rem;
          margin: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
        v-if="spinning"
      ></b-spinner>
      <div v-for="(tourId, j) in tourOrder" :key="j">
        <li
          class="list-group-item"
          style="background: #212225; margin: auto"
          v-if="cookiesObject.token"
        >
          <router-link
            style="color: #e6e6e6"
            id="router-link-league"
            :to="{
              name: 'LeaguePageNav',
              params: { leagueId: tournaments[tourId][0].tournament.id },
            }"
          >
            <img
              v-if="tournaments[tourId][0].tournament.category.icon == null"
              src="@/assets/int.png"
              style="width: 17px"
              alt=""
            />
            <img
              v-else
              :src="leagueLogo + tournaments[tourId][0].tournament.category.id"
              style="width: 17px; margin-right: 5px"
              alt=""
            />
            {{
              tournaments[tourId][0].tournament.name
                | transliterate(cookiesObject.lang)
            }}
            <span style="float: right">{{
              woolo | transliterate(cookiesObject.lang)
            }}</span>
          </router-link>
          <b-btn
            v-if="
              favsT.some(
                (fav) => fav.id === tournaments[tourId][0].tournament.id
              )
            "
            v-on:click="
              removeFavorite({
                value: tournaments[tourId][0].tournament.id,
                type: tournament,
              })
            "
            style="background: none; width: 5px; height: 5px; border: none"
          >
            <img
              src="@/assets/orStar.png"
              style="width: 15px; margin-top: -32px; margin-left: -10px"
              alt=""
            />
          </b-btn>
          <b-btn
            v-else
            v-on:click="
              addToFavorites({
                value: tournaments[tourId][0].tournament.id,
                type: tournament,
              })
            "
            style="background: none; width: 5px; height: 5px; border: none"
          >
            <img
              src="@/assets/favorite.svg"
              style="width: 15px; margin-top: -32px; margin-left: -10px"
              alt=""
            />
          </b-btn>
        </li>
        <li
          class="list-group-item"
          style="background: #212225; color: #e6e6e6; margin: auto"
          v-else-if="!cookiesObject.token"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          <img
            v-if="tournaments[tourId][0].tournament.category.icon == null"
            src="@/assets/int.png"
            style="width: 17px"
            alt=""
          />
          <img
            v-else
            :src="leagueLogo + tournaments[tourId][0].tournament.category.id"
            style="width: 17px; margin-right: 5px"
            alt=""
          />
          <span style="cursor: pointer">{{
            tournaments[tourId][0].tournament.name
              | transliterate(cookiesObject.lang)
          }}</span>
          <span style="float: right">{{
            woolo | transliterate(cookiesObject.lang)
          }}</span>
          <b-btn
            style="background: none; width: 5px; height: 5px; border: none"
          >
            <img
              src="@/assets/favorite.svg"
              style="width: 15px; margin-top: -32px; margin-left: -5px"
              alt=""
            />
          </b-btn>
        </li>
        <div v-for="(game, i) in tournaments[tourId]" :key="i" class="gamebg">
          <li
            class="list-group-item game"
            style="background: #141416"
            v-if="cookiesObject.token"
          >
            <div class="row">
              <div class="col-1 bodyElement mr-0 pr-3" style="">
                <div v-if="!cookiesObject.token">
                  <b-btn
                    data-toggle="modal"
                    data-target="#exampleModal"
                    style="
                      float: right;
                      background: none;
                      width: 5px;
                      height: 5px;
                      border: none;
                    "
                  >
                    <img
                      src="@/assets/favorite.svg"
                      style="width: 15px; margin-top: -30px; margin-left: -10px"
                      alt=""
                    />
                  </b-btn>
                </div>
                <div v-else>
                  <b-btn
                    v-if="favsTe.some((fav) => fav.id === game.id)"
                    v-on:click="removeFavorite({ value: game.id, type: match })"
                    style="
                      float: right;
                      background: none;
                      width: 5px;
                      height: 5px;
                      border: none;
                    "
                  >
                    <img
                      src="@/assets/orStar.png"
                      style="width: 15px; margin-top: -30px; margin-left: -10px"
                      alt=""
                    />
                  </b-btn>
                  <b-btn
                    v-else
                    v-on:click="addToFavorites({ value: game.id, type: match })"
                    style="
                      float: right;
                      background: none;
                      width: 5px;
                      height: 5px;
                      border: none;
                    "
                  >
                    <img
                      src="@/assets/favorite.svg"
                      style="width: 15px; margin-top: -30px; margin-left: -10px"
                      alt=""
                    />
                  </b-btn>
                </div>
              </div>
              <router-link
                style="color: #e6e6e6"
                class="col ml-0 pl-0"
                id="router-link"
                :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
              >
                <div class="row">
                  <div class="col-1 bodyElement">
                    <p v-if="game.matchStatus.name == 'FT'">
                      {{ game.matchStatus.name }}
                    </p>
                    <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                    <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                    <p v-else-if="game.matchStatus.name == 'NS'">
                      {{
                        game.matchTime.slice(11, 16)
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                    <p v-else-if="game.matchStatus.name == 'LIVE'">
                      {{ calculateMinutes(game.counterStartTime)
                      }}<img
                        src="@/assets/redLight.gif"
                        style="width: 5px; position: absolute; margin-top: -4px"
                        alt="'"
                      />
                    </p>
                    <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                    <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                    <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                    <p v-else>{{ game.matchStatus.name }}</p>
                  </div>
                  <div
                    class="col bodyElement"
                    :style="
                      rtl
                        ? 'margin-top: -5px; text-align: left;'
                        : 'margin-top: -5px; text-align: right;'
                    "
                  >
                    {{
                      game.team1.name.slice(0, 22)
                        | transliterate(cookiesObject.lang)
                    }}
                    <img
                      :src="teamLogo + game.team1.id"
                      alt=""
                      style="width: 20px"
                    />
                  </div>
                  <div
                    class="col-2 bodyElement"
                    v-if="
                      game.matchStatus.name == 'NS' ||
                      game.matchStatus.name == 'POSTP' ||
                      game.matchStatus.name == 'CANCL' ||
                      game.matchStatus.name == 'TBA'
                    "
                    style="letter-spacing: 3px"
                  >
                    -
                  </div>
                  <div
                    class="col-2 bodyElement"
                    style="letter-spacing: 3px"
                    v-else
                  >
                    {{ game.currentScore | transliterate(cookiesObject.lang) }}
                  </div>
                  <div
                    class="col bodyElement"
                    :style="
                      rtl
                        ? 'margin-top: -5px; text-align: right;'
                        : 'margin-top: -5px; text-align: left;'
                    "
                  >
                    <img
                      :src="teamLogo + game.team2.id"
                      alt=""
                      style="width: 20px"
                    />
                    {{
                      game.team2.name.slice(0, 22)
                        | transliterate(cookiesObject.lang)
                    }}
                  </div>
                </div>
              </router-link>
              <div class="col-2 ml-0 pl-5 bodyElement" style="">
                <div>
                  <span
                    v-if="game.betEnabled == 1 && game.predictionValue != null"
                    style="
                      border: 1px solid #444548;
                      background: #27292c;
                      border-radius: 2px;
                      padding: 3px;
                      letter-spacing: 2px;
                      color: #e6e6e6;
                    "
                  >
                    {{ game.predictionValue }}
                  </span>
                  <span
                    v-else-if="
                      game.betEnabled == 1 &&
                      game.predictionValue == null &&
                      game.matchStatus.name == 'NS'
                    "
                  >
                    <router-link
                      style="color: #e6e6e6; text-decoration: none"
                      class=""
                      id=""
                      :to="{
                        name: 'MatchPagePar',
                        params: { gameId: game.id, index: 3 },
                      }"
                    >
                      <img
                        style="width: 24px; margin-top: -8px"
                        src="@/assets/scoreboard.svg"
                      />
                    </router-link>
                  </span>
                  <span v-else style=""></span>
                </div>
              </div>
            </div>
          </li>
          <li
            class="list-group-item game"
            v-else
            data-toggle="modal"
            data-target="#exampleModal"
            style="cursor: pointer; background: #141416; color: white"
          >
            <div class="row">
              <div class="col-1 mr-0 pr-3 bodyElement">
                <div>
                  <b-btn
                    style="
                      float: right;
                      background: none;
                      width: 5px;
                      height: 5px;
                      border: none;
                    "
                  >
                    <img
                      src="@/assets/favorite.svg"
                      style="width: 15px; margin-top: -30px; margin-left: -10px"
                      alt=""
                    />
                  </b-btn>
                </div>
              </div>
              <div class="col-1 ml-0 pl-0 bodyElement">
                <p v-if="game.matchStatus.name == 'FT'">
                  {{ game.matchStatus.name }}
                </p>
                <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                <p v-else-if="game.matchStatus.name == 'NS'">
                  {{
                    game.matchTime.slice(11, 16)
                      | transliterate(cookiesObject.lang)
                  }}
                </p>
                <p v-else-if="game.matchStatus.name == 'LIVE'">
                  {{ calculateMinutes(game.counterStartTime)
                  }}<img
                    src="@/assets/redLight.gif"
                    style="width: 5px; position: absolute; margin-top: -4px"
                    alt="'"
                  />
                </p>
                <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                <p v-else>{{ game.matchStatus.name }}</p>
              </div>
              <div
                class="col bodyElement"
                :style="
                  rtl
                    ? 'margin-top: -5px; text-align: left;'
                    : 'margin-top: -5px; text-align: right;'
                "
              >
                {{
                  game.team1.name.slice(0, 22)
                    | transliterate(cookiesObject.lang)
                }}
                <img
                  :src="teamLogo + game.team1.id"
                  alt=""
                  style="width: 20px"
                />
              </div>
              <div
                class="col-2 bodyElement"
                v-if="
                  game.matchStatus.name == 'NS' ||
                  game.matchStatus.name == 'POSTP' ||
                  game.matchStatus.name == 'CANCL' ||
                  game.matchStatus.name == 'TBA'
                "
                style="letter-spacing: 3px"
              >
                -
              </div>
              <div class="col-2 bodyElement" style="letter-spacing: 3px" v-else>
                {{ game.currentScore | transliterate(cookiesObject.lang) }}
              </div>
              <div
                class="col bodyElement"
                :style="
                  rtl
                    ? 'margin-top: -5px; text-align: right;'
                    : 'margin-top: -5px; text-align: left;'
                "
              >
                <img
                  :src="teamLogo + game.team2.id"
                  alt=""
                  style="width: 20px"
                />
                {{
                  game.team2.name.slice(0, 22)
                    | transliterate(cookiesObject.lang)
                }}
              </div>
              <div class="col-2 ml-0 pl-5 bodyElement" style="">
                <div>
                  <span
                    v-if="game.betEnabled == 1 && game.predictionValue != null"
                    style="
                      border: 1px solid #444548;
                      background: #27292c;
                      border-radius: 2px;
                      padding: 3px;
                      letter-spacing: 2px;
                    "
                  >
                    {{ game.predictionValue }}
                  </span>
                  <span
                    v-else-if="
                      game.betEnabled == 1 &&
                      game.predictionValue == null &&
                      game.matchStatus.name == 'NS'
                    "
                    ><img
                      style="width: 24px; margin-top: -8px"
                      src="@/assets/scoreboard.svg"
                  /></span>
                  <span v-else style=""> </span>
                </div>
              </div>
            </div>
          </li>
        </div>
      </div>
    </ul>
    <ul class="list-group MobileShow pl-0 pr-0">
      <div v-if="cookiesObject.token">
        <li
          class="list-group-item"
          style="
            background: rgba(190, 135, 51, 0.3);
            color: lightgrey;
            line-height: 7px;
            padding-left: 5px;
          "
          v-if="findCommonElements()"
        >
          <img
            src="@/assets/orStar.png"
            style="width: 14px; margin-top: -4px; margin-right: 5px"
            alt=""
          />{{ $t("LanguageEn.myTeamsMatches")
          }}<span style="float: right">{{ woolo }}</span>
        </li>
        <div v-for="fav in favs" :key="fav.id" style="width: 100%">
          <div v-for="gamee in games" :key="gamee.id">
            <li
              class="list-group-item game"
              style="background: #141416"
              v-if="fav.id == gamee.team2.id || fav.id == gamee.team1.id"
            >
              <div class="row">
                <router-link
                  class="col"
                  id="router-link"
                  style="color: lightgrey"
                  :to="{ name: 'MatchPagePar', params: { gameId: gamee.id } }"
                >
                  <div class="row">
                    <div
                      class="col-1 bodyElement"
                      style="margin-top: 15px; margin-right: 5px"
                    >
                      <p v-if="gamee.matchStatus.name == 'FT'">
                        {{ gamee.matchStatus.name }}
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'FT_PEN'">FT</p>
                      <p v-else-if="gamee.matchStatus.name == 'BREAK'">BR</p>
                      <p v-else-if="gamee.matchStatus.name == 'POSTP'">PST</p>
                      <p v-else-if="gamee.matchStatus.name == 'NS'">
                        {{
                          gamee.matchTime.slice(11, 16)
                            | transliterate(cookiesObject.lang)
                        }}
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'TBA'">TB</p>
                      <p v-else-if="gamee.matchStatus.name == 'AWARDED'">AWR</p>
                      <p v-else-if="gamee.matchStatus.name == 'LIVE'">
                        {{ calculateMinutes(gamee.counterStartTime)
                        }}<img
                          src="@/assets/redLight.gif"
                          style="
                            width: 5px;
                            position: absolute;
                            margin-top: -4px;
                          "
                          alt="'"
                        />
                      </p>
                      <p v-else-if="gamee.matchStatus.name == 'CANCL'">CAN</p>
                      <p v-else>{{ gamee.matchStatus.name }}</p>
                    </div>
                    <div
                      class="col"
                      style="text-align: left; font-size: 11px; margin-top: 4px"
                    >
                      <div class="bodyElement" style="margin-bottom: 10px">
                        <img
                          :src="teamLogo + gamee.team1.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          gamee.team1.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div class="bodyElement">
                        <img
                          :src="teamLogo + gamee.team2.id"
                          alt=""
                          style="width: 12px; margin-right: 4px"
                        />{{
                          gamee.team2.name.slice(0, 20)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                    <div class="col-2 bodyElement" style="">
                      <div>
                        <div
                          v-if="
                            gamee.betEnabled == 1 &&
                            gamee.predictionValue != null
                          "
                          style="
                            border: 1px solid #444548;
                            background: #27292c;
                            border-radius: 2px;
                            padding: 5px;
                            letter-spacing: 2px;
                            color: #e6e6e6;
                            margin-top: 8px;
                          "
                        >
                          {{ gamee.predictionValue }}
                        </div>
                        <span
                          v-else-if="
                            gamee.betEnabled == 1 &&
                            gamee.predictionValue == null &&
                            gamee.matchStatus.name == 'NS'
                          "
                        >
                          <router-link
                            style="color: #e6e6e6; text-decoration: none"
                            class=""
                            id=""
                            :to="{
                              name: 'MatchPagePar',
                              params: { gameId: gamee.id, index: 3 },
                            }"
                          >
                            <img
                              style="width: 24px; margin-top: 5px"
                              src="@/assets/scoreboard.svg"
                            />
                          </router-link>
                        </span>
                        <span v-else style=""></span>
                      </div>
                    </div>
                    <div
                      class="col-1"
                      v-if="gamee.matchStatus.name == 'NS'"
                      style="font-weight: 400; margin-top: 4px"
                    >
                      <div style="margin-bottom: 15px">?</div>
                      <div>?</div>
                    </div>
                    <div class="col-1" v-else style="margin-top: 4px">
                      <div style="margin-bottom: 15px">
                        {{
                          gamee.currentScore.slice(0, 1)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <div>
                        {{
                          gamee.currentScore.slice(2, 3)
                            | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                  </div>
                </router-link>
                <div class="col-1 bodyElement" style="margin-top: 4px">
                  <div>
                    <img
                      src="@/assets/orStar.png"
                      v-if="favsTe.some((fav) => fav.id === gamee.id)"
                      v-on:click="
                        removeFavorite({ value: gamee.id, type: match })
                      "
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                    <img
                      v-else
                      v-on:click="
                        addToFavorites({ value: gamee.id, type: match })
                      "
                      src="@/assets/favorite.svg"
                      style="width: 16px; margin-top: 5px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>
      <b-spinner
        variant="success"
        label="Spinning"
        style="
          width: 3rem;
          height: 3rem;
          margin: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
        v-if="spinning"
      ></b-spinner>
      <div v-for="(tourId, j) in tourOrder" :key="j">
        <li
          class="list-group-item"
          style="background: #212225; color: lightgrey; padding-left: 5px"
          v-if="cookiesObject.token"
        >
          <router-link
            id="router-link-league"
            style="color: lightgrey"
            :to="{
              name: 'LeaguePageNav',
              params: { leagueId: tournaments[tourId][0].tournament.id },
            }"
          >
            <img
              v-if="tournaments[tourId][0].tournament.category.icon == null"
              src="@/assets/int.png"
              style="width: 17px; margin-right: 0px; margin-top: -2px"
              alt=""
            />
            <img
              v-else
              :src="leagueLogo + tournaments[tourId][0].tournament.category.id"
              style="width: 17px; margin-right: 5px; margin-top: -2px"
              alt=""
            />
            {{ tournaments[tourId][0].tournament.name }}
            <span style="float: right; margin-top: 5px">{{ woolo }}</span>
          </router-link>
          <img
            v-if="
              favsT.some(
                (fav) => fav.id === tournaments[tourId][0].tournament.id
              )
            "
            v-on:click="
              removeFavorite({
                value: tournaments[tourId][0].tournament.id,
                type: tournament,
              })
            "
            src="@/assets/orStar.png"
            style="width: 15px; margin-top: -3px; margin-left: 5px"
            alt=""
          />
          <img
            v-else
            v-on:click="
              addToFavorites({
                value: tournaments[tourId][0].tournament.id,
                type: tournament,
              })
            "
            src="@/assets/favorite.svg"
            style="width: 15px; margin-top: -3px; margin-left: 5px"
            alt=""
          />
        </li>
        <li
          class="list-group-item"
          style="background: #212225; color: lightgrey; padding-left: 5px"
          v-else-if="!cookiesObject.token"
          v-b-modal.modal-multi-1
        >
          <img
            v-if="tournaments[tourId][0].tournament.category.icon == null"
            src="@/assets/int.png"
            style="width: 17px; margin-right: 2px; margin-top: -2px"
            alt=""
          />
          <img
            v-else
            :src="leagueLogo + tournaments[tourId][0].tournament.category.id"
            style="width: 17px; margin-right: 2px; margin-top: -2px"
            alt=""
          />
          <span style="margin: auto">
            {{ tournaments[tourId][0].tournament.name }}
          </span>
          <img
            src="@/assets/favorite.svg"
            style="width: 15px; margin-top: -3px; margin-left: 5px"
            alt=""
          />
          <span style="float: right; margin-top: 5px">{{ woolo }}</span>
        </li>
        <div v-for="(game, i) in tournaments[tourId]" :key="i">
          <li
            class="list-group-item game"
            style="background: #141416"
            v-if="cookiesObject.token"
          >
            <div class="row">
              <router-link
                class="col"
                id="router-link"
                style="color: lightgrey"
                :to="{ name: 'MatchPagePar', params: { gameId: game.id } }"
              >
                <div class="row">
                  <div
                    class="col-1 bodyElement"
                    style="margin-top: 15px; margin-right: 5px"
                  >
                    <p v-if="game.matchStatus.name == 'FT'">
                      {{ game.matchStatus.name }}
                    </p>
                    <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                    <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                    <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                    <p v-else-if="game.matchStatus.name == 'NS'">
                      {{
                        game.matchTime.slice(11, 16)
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                    <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                    <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                    <p v-else-if="game.matchStatus.name == 'LIVE'" class="pop">
                      {{ calculateMinutes(game.counterStartTime) }}'
                    </p>
                    <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                    <p v-else>{{ game.matchStatus.name }}</p>
                  </div>
                  <div
                    class="col"
                    style="text-align: left; font-size: 11px; margin-top: 4px"
                  >
                    <div class="bodyElement" style="margin-bottom: 10px">
                      <img
                        :src="teamLogo + game.team1.id"
                        alt=""
                        style="width: 12px; margin-right: 4px"
                      />{{
                        game.team1.name.slice(0, 20)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div class="bodyElement">
                      <img
                        :src="teamLogo + game.team2.id"
                        alt=""
                        style="width: 12px; margin-right: 4px"
                      />{{
                        game.team2.name.slice(0, 20)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                  </div>
                  <div class="col-2 bodyElement" style="">
                    <div>
                      <div
                        v-if="
                          game.betEnabled == 1 && game.predictionValue != null
                        "
                        style="
                          border: 1px solid #444548;
                          background: #27292c;
                          border-radius: 2px;
                          padding: 5px;
                          letter-spacing: 2px;
                          color: #e6e6e6;
                          margin-top: 8px;
                        "
                      >
                        {{ game.predictionValue }}
                      </div>
                      <span
                        v-else-if="
                          game.betEnabled == 1 &&
                          game.predictionValue == null &&
                          game.matchStatus.name == 'NS'
                        "
                      >
                        <router-link
                          style="color: #e6e6e6; text-decoration: none"
                          class=""
                          id=""
                          :to="{
                            name: 'MatchPagePar',
                            params: { gameId: game.id, index: 3 },
                          }"
                        >
                          <img
                            style="width: 24px; margin-top: 5px"
                            src="@/assets/scoreboard.svg"
                          />
                        </router-link>
                      </span>
                      <span v-else style=""></span>
                    </div>
                  </div>
                  <div
                    class="col-1"
                    v-if="game.matchStatus.name == 'NS'"
                    style="font-weight: 400; margin-top: 4px"
                  >
                    <div style="margin-bottom: 15px">?</div>
                    <div>?</div>
                  </div>
                  <div class="col-1" v-else style="margin-top: 4px">
                    <div style="margin-bottom: 15px">
                      {{
                        game.currentScore.slice(0, 1)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div>
                      {{
                        game.currentScore.slice(2, 3)
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                  </div>
                </div>
              </router-link>
              <div class="col-1 bodyElement" style="margin-top: 4px">
                <div>
                  <img
                    v-if="favsTe.some((fav) => fav.id === game.id)"
                    v-on:click="removeFavorite({ value: game.id, type: match })"
                    src="@/assets/orStar.png"
                    style="width: 16px; margin-top: 5px"
                    alt=""
                  />
                  <img
                    v-else
                    v-on:click="addToFavorites({ value: game.id, type: match })"
                    src="@/assets/favorite.svg"
                    style="width: 16px; margin-top: 5px"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </li>
          <li
            class="list-group-item game"
            style="background: #141416; color: lightgrey"
            v-else
            v-b-modal.modal-multi-1
          >
            <div class="row">
              <div
                class="col-1 bodyElement"
                style="margin-top: 15px; margin-right: 5px"
              >
                <p v-if="game.matchStatus.name == 'FT'">
                  {{ game.matchStatus.name }}
                </p>
                <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
                <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
                <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
                <p v-else-if="game.matchStatus.name == 'NS'">
                  {{
                    game.matchTime.slice(11, 16)
                      | transliterate(cookiesObject.lang)
                  }}
                </p>
                <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>
                <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>
                <p v-else-if="game.matchStatus.name == 'LIVE'" class="pop">
                  {{ calculateMinutes(game.counterStartTime) }}'
                </p>
                <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>
                <p v-else>{{ game.matchStatus.name }}</p>
              </div>
              <div
                class="col"
                style="text-align: left; font-size: 11px; margin-top: 4px"
              >
                <div class="bodyElement" style="margin-bottom: 10px">
                  <img
                    :src="teamLogo + game.team1.id"
                    alt=""
                    style="width: 12px; margin-right: 4px"
                  />{{
                    game.team1.name.slice(0, 20)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div class="bodyElement">
                  <img
                    :src="teamLogo + game.team2.id"
                    alt=""
                    style="width: 12px; margin-right: 4px"
                  />{{
                    game.team2.name.slice(0, 20)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
              </div>
              <div class="col-2 bodyElement" style="">
                <div>
                  <div
                    v-if="game.betEnabled == 1 && game.predictionValue != null"
                    style="
                      border: 1px solid #444548;
                      background: #27292c;
                      border-radius: 2px;
                      padding: 5px;
                      letter-spacing: 2px;
                      color: #e6e6e6;
                      margin-top: 8px;
                    "
                  >
                    {{ game.predictionValue }}
                  </div>
                  <span
                    v-else-if="
                      game.betEnabled == 1 &&
                      game.predictionValue == null &&
                      game.matchStatus.name == 'NS'
                    "
                  >
                    <img
                      style="width: 24px; margin-top: 5px"
                      src="@/assets/scoreboard.svg"
                    />
                  </span>
                  <span v-else style=""></span>
                </div>
              </div>
              <div
                class="col-1"
                v-if="game.matchStatus.name == 'NS'"
                style="font-weight: 500; margin-top: 4px"
              >
                <div style="margin-bottom: 15px">?</div>
                <div>?</div>
              </div>
              <div class="col-1" v-else style="margin-top: 4px">
                <div style="margin-bottom: 15px">
                  {{
                    game.currentScore.slice(0, 1)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div>
                  {{
                    game.currentScore.slice(2, 3)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
              </div>
              <div class="col-1 bodyElement" style="margin-top: 4px">
                <div>
                  <img
                    src="@/assets/favorite.svg"
                    v-b-modal.modal-multi-1
                    style="width: 16px; margin-top: 5px"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </li>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Finished",
  data() {
    return {
      games: [],
      value: "",
      spinning: "",
      cookiesObject: "",
      leagueLogo: "https://sportapi.zuniac.com/category/logo/",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      dateS: "",
      match: "match",
      tournaments: {},
      tourOrder: [],
      woolo: "",
      tournament: "tournament",
    };
  },
  async mounted() {
    this.dateS = this.$route.params.dateS;

    if (this.dateS == this.getDate1()) {
      this.$router.push({ name: "Today" });
    }

    this.spinning = true;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    var offset = new Date().getTimezoneOffset();

    if (cookiesObject.token) {
      const res = await fetch(
        this.httpReq +
          "/sport/matches?date=" +
          this.dateS +
          "&langId=" +
          this.cookiesObject.langId +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&sportId=1&timezone=%2B" +
          offset / -60 +
          "%3A00&token=" +
          cookiesObject.token
      );
      const data = await res.json();
      const games = data.matches;
      this.games = games;

      if (data.code == 200) {
        //everything is okay
      } else if (data.code == 401) {
        alert(this.$t("LanguageEn.logText"));
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 404) {
        alert("Token is not valid and portal id not provided");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else if (data.code == 500) {
        alert("Oops, something went wrong!");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      } else {
        alert("service error");
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }
    } else {
      const res = await fetch(
        this.httpReq +
          "/sport/matches?date=" +
          this.dateS +
          "&langId=" +
          this.cookiesObject.langId +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&sportId=1&timezone=%2B" +
          offset / -60 +
          "%3A00"
      );
      const data = await res.json();
      const games = data.matches;
      this.games = games;
    }

    this.headerDate();

    const tournaments = {};
    const tourOrder = [];

    this.games.forEach((e) => {
      const tourid = e.tournament.id;

      if (typeof tournaments[tourid] === "undefined") {
        tournaments[tourid] = [];
        tourOrder.push(tourid);
      }

      tournaments[tourid].push(e);
    });

    // this.games = games;
    this.tournaments = tournaments;

    for (var el in this.tournaments) {
      tournaments[el] = tournaments[el].reverse();
    }

    this.tourOrder = tourOrder;

    this.findCommonElements();

    this.spinning = false;
  },

  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
    headerDate() {
      var dateObj = new Date(this.dateS);
      var month = dateObj.getUTCMonth();

      this.woolo = this.monthNames[month] + " " + this.dateS.slice(8, 10);
    },

    findCommonElements() {
      let result = this.games.map((a) => a.team1.id);
      let result1 = this.games.map((a) => a.team2.id);

      var finalarr = result.concat(result1);

      let result2 = this.favs.map((a) => a.id);

      const found = result2.some((r) => finalarr.includes(r));

      return found;
    },
    getDate1() {
      var dt = new Date();
      dt.setDate(dt.getDate());
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    calculateMinutes(value) {
      if (value == null) {
        return "LIVE";
      } else {
        var startDate = new Date(value.replace(" ", "T"));
        var endDate = Date.now();
        var difference = (endDate - startDate) / 1000 / 60;

        if (difference < 0) {
          difference = difference + 240;
        }

        return parseInt(difference);
      }
    },
  },
  components: {},
  props: {},
  computed: {
    ...mapGetters(["favsTe", "favs", "favsT", "httpReq", "rtl"]),
    monthNames() {
      return [
        this.$t("LanguageEn.month1"),
        this.$t("LanguageEn.month2"),
        this.$t("LanguageEn.month3"),
        this.$t("LanguageEn.month4"),
        this.$t("LanguageEn.month5"),
        this.$t("LanguageEn.month6"),
        this.$t("LanguageEn.month7"),
        this.$t("LanguageEn.month8"),
        this.$t("LanguageEn.month9"),
        this.$t("LanguageEn.month10"),
        this.$t("LanguageEn.month11"),
        this.$t("LanguageEn.month12"),
      ];
    },
  },

  watch: {},
};
</script>

<style scoped>
.mainC {
  margin-top: 2px;
  font-weight: 500;
}
#router-link {
  color: black;
  text-decoration: none;
}

.container {
  margin-top: 12px;
}
#router-link-league {
  color: black;
  text-decoration: none;
}

li {
  line-height: 5px;
  border-radius: 0px !important;
  font-size: 12px;
}
.LeagueName {
  margin-bottom: 10px;
}

.header {
  background: #d6d6d6;
  color: white;
}

.bodyElement {
  padding: 0;
  height: 8px;
}

.game {
  text-align: center;
}
.gamebg :hover {
  background: #27292c !important;
}

@media only screen and (max-width: 770px) {
  .bodyElement {
    padding: 0;
    height: 8px;
  }
  .MobileHide {
    display: none;
  }
}
</style>
